import * as types from '../constants/ActionTypes'
import {constants as kandyConstants} from 'kandy-redux'
import {handleActions} from 'redux-actions'

const reducers = {}
const initialState = {
	userInfo: {
		agentRole: {

		},
		tenant: {
			statisticsMenus: [],
			manualOptPermissions: [],
			riskContrMod: {
				riskMarks: []
			}
		}
	}
}

/**
 * While fetching agent's details, reset all flags.
 */
reducers[types.GET_AGENT] = (state, action) => {
	return Object.assign({}, state, {
		isLoading: true,
		isUpdating: false,
		isLoaded: false,
		isUpdated: false,
		loadError: false,
		updateError: false,
		kandyStatus: false
	})
}

/**
 * Handles receiving the get agent request response
 */
reducers[types.GET_AGENT_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			userInfo: action.payload.agent,
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.UPDATE_AGENT] = (state, action) => {
	return Object.assign({}, state, {isUpdating: true, isUpdated: false, updateError: false})
}

/**
 * Handles receiving the update agent password request response
 */
reducers[types.UPDATE_AGENT_PASSWORD_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			userInfo: action.payload.agent,
			isUpdatingPassword: false,
			isUpdatedPassword: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isUpdatingPassword: false, updatePasswordError: true})
	}
}

reducers[types.UPDATE_AGENT_PASSWORD] = (state, action) => {
	return Object.assign({}, state, {isUpdatingPassword: true, isUpdatedPassword: false, updatePasswordError: false})
}

reducers[types.UPDATE_CURRENTAGENT_STATE] = (state, action) => {
	return Object.assign({}, state, {userInfo: Object.assign({}, state.userInfo, {agentState: action.payload.stateCode})})
}
reducers[types.UPDATE_CURRENTAGENT_LOGIN_STATE] = (state, action) => {
	return Object.assign({}, state, {userInfo: Object.assign({}, state.userInfo, {isLoggedIn: action.payload.isLoggedIn})})
}
reducers[types.UPDATE_AGENT_KANDY_STATUS] = (state, action) => {
    return Object.assign({}, state, {kandyStatus: action.payload.status})
}
/**
 * Handles sending the password reset email
 */
reducers[types.EMAIL_PASSWORD_RESET_LINK_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			isSendingPasswordResetEmail: false,
			isSentPasswordResetEmail: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isSendingPasswordResetEmail: false, sendPasswordResetEmailError: true})
	}
}

reducers[types.EMAIL_PASSWORD_RESET_LINK] = (state, action) => {
	return Object.assign({}, state, {
		isSendingPasswordResetEmail: true,
		isSentPasswordResetEmail: false,
		sendPasswordResetEmailError: false
	})
}

/**
 * Handles receiving the update agent request response
 */
reducers[types.UPDATE_AGENT_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			userInfo: action.payload.agent,
			isUpdating: false,
			isUpdated: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isUpdating: false, updateError: true})
	}
}

reducers[types.EMAIL_CHAT_MESSAGES] = (state, action) => {
	return Object.assign({}, state, {isEmailSending: true, isEmailSent: false})
}

reducers[types.EMAILED_CHAT_MESSAGES] = {
	next(state, action) {
		return Object.assign({}, state, {
			isEmailSending: false,
			isEmailSent: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isEmailSending: false, isEmailSent: true, emailSendError: true})
	}
}

reducers[types.MAKE_KANDY_CALL] = {
	next(state, action) {
		return Object.assign({}, state, {
			userInfo: Object.assign({}, state.userInfo, {
				isCallOn: true,
				isCallIncoming: false
			})
		})
	}
}

reducers[kandyConstants.CALL_INCOMING] = {
	next(state, action) {
		if (!state.userInfo.callId)
			return Object.assign({}, state, {
				userInfo: Object.assign({}, state.userInfo, {
					isCallIncoming: true,
					callerNumber: action.payload.callerNumber
				})
			})
		else
			return state
	}
}


reducers[types.END_SESSION] = (state, action) => {

	if (action.payload.callId === state.userInfo.callId)
		return Object.assign({}, state, {userInfo: Object.assign({}, state.userInfo, {isCallOn: false})})
	else
		return Object.assign({}, state, {
			userInfo: Object.assign({}, state.userInfo, {
				isCallIncoming: false,
				callerNumber: ''
			})
		})
}


reducers[types.UPDATE_AGENT_PROFILE_FINISH] =  {
    next(state, action){
    	if(action.error){
            return Object.assign({}, state, {updateProfileError:true})
		}else{
            return Object.assign({}, state, {userInfo: Object.assign({}, state.userInfo,action.payload ),updateProfileError:false})
        }
    },
    throw(state){
        return Object.assign({}, state, {updateProfileError:true})
    }
}
reducers[types.RESET_PWD_FINISH] =  {
    next(state, action){
        return Object.assign({}, state, {userInfo: Object.assign({}, state.userInfo,action.payload ),resetPwdError:false})
    },
    throw(state){
        return Object.assign({}, state, {resetPwdError:true})
    }
}

reducers[types.CLEAR_HINT_MSG] = (state,action) => {
	return Object.assign({}, state, {updateProfileError:undefined})
}

reducers[types.CLEAR_RESET_HINT_MSG] = (state,action) => {
    return Object.assign({}, state, {resetPwdError:undefined})
}

reducers[types.SET_AGENT_SERVICE_STATUS_FINISH] = (state, action)=>{
	if (!action.error) {
        return Object.assign({}, state, {agentServiceStatus: action.payload})
	} else {
        return Object.assign({}, state)
	}
}

export default handleActions(reducers, initialState)
